<template>
  <div class="overlay-modal" @click="closeSelf">
    <div class="overlay-modal__scroller">
      <div class="overlay-modal__inner-container" ref="modal">
        <span
          v-if="closable"
          @click.self="closeSelf"
          class="overlay-modal__close-icon"
          ref="close"
        >
          <XMarkSVG />
        </span>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import XMarkSVG from "@/assets/svg/x-mark.svg"
export default {
  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    XMarkSVG
  },
  methods: {
    /**
     * Closes modal on overlay or close button click
     * @param {Object} - Event object (received by default)
     */
    closeSelf(event) {
      if (
        this.closable &&
        (this.$refs.close.contains(event.target) ||
          !this.$refs.modal.contains(event.target))
      ) {
        this.$store.dispatch("closeModal")
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.overlay-modal {
  width: 100vw;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  overflow-y: auto;
  z-index: 99;
  text-align: center;
  top: 0;
  left: 0;
  $color-neutral-3--06: rgba($color-neutral-3, 0.6);
  background: $color-neutral-3--06;
  background: var(--color-neutral-3--06, $color-neutral-3--06);
  &__scroller {
    height: 100%;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
  }
  &__inner-container {
    position: relative;
    display: inline-block;
    text-align: initial;
    min-height: 200px;
    min-width: 200px;
    max-width: 90%;
    background: white;
    margin: 7% auto;
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.2);
    & > div {
      padding: 60px 40px 53px;
    }
  }

  &__close-icon {
    position: absolute;
    right: 25px;
    top: 25px;
    cursor: pointer;
    svg {
      stroke: $color-primary--dark;
      stroke: var(--color-primary--dark, $color-primary--dark);
    }
  }
}
</style>
